import { render, staticRenderFns } from "./eduProceed.vue?vue&type=template&id=45ff658c&scoped=true"
import script from "./eduProceed.vue?vue&type=script&lang=js"
export * from "./eduProceed.vue?vue&type=script&lang=js"
import style0 from "./eduProceed.vue?vue&type=style&index=0&id=45ff658c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff658c",
  null
  
)

export default component.exports